
export class Activity<WorkType> {
    public actions = new Map<WorkType, Status>();

    constructor(actions: { [key: string]: string | number }) {
        Object.values(actions)
            .forEach((action: unknown) => this.actions.set(action as WorkType, Status.Idle));
    }

    public get isBusy(): boolean {
        return this.statuses.some(status => status === Status.InProgress);
    }

    private get statuses() {
        return Array.from(this.actions.values());
    }

    public isBusyWith(work: WorkType): boolean {
        return this.actions.get(work) === Status.InProgress;
    }

    public do(work: WorkType) {
        this.actions.set(work, Status.InProgress);
    }

    public complete(work: WorkType) {
        this.actions.set(work, Status.Done);
    }

    public fail(work: WorkType) {
        this.actions.set(work, Status.Failed)
    }

    public cancel(work: WorkType) {
        this.actions.set(work, Status.Idle);
    }

    public track(work: WorkType) {
        const activity = this;
        return {
            async operation<Result>(operation: (() => Promise<Result>) | Promise<Result>) {
              let result:Result;
                activity.do(work);
                try {
                    result = await (typeof operation === 'function' ? operation() : operation);
                } catch (error) {
                    activity.fail(work);
                    throw error;
                } finally {
                    activity.complete(work);
                }
                return result;
            }
        }
    }

    public hasCompleted(work: WorkType) {
        return this.actions.get(work) === Status.Done;
    }
}

export enum Status {
    Idle = 'Idle',
    InProgress = 'InProgress',
    Done = 'Done',
    Failed = 'Failed',
}
